import { pathOr } from 'ramda';

import { IFeaturesMap } from '../../../common/types/map';
import { IApplicationState } from '../../../common/types/redux';
import { selectMapBounds } from '../mapBounds';

export const selectFeaturesForPrecision = (state: IApplicationState) => {
  const { precision } = selectMapBounds(state);

  return pathOr<IFeaturesMap>({}, [precision, 'features'], state.map.features);
};
